export const CORSI = [
  {
    slug: "agente-di-commercio",
    codice: "ARC",
    categoria: "Corso abilitante",
    categoriaColor: "#003B75",
    categoriaBg: "#EBF5FF",
    titolo: "Corso per Agente di Commercio",
    dataInizio: "13 Aprile 2026",
    dataFine: "16 Giugno 2026",
    dataEsame: "17 Giugno 2026",
    sessioni: [
      { dataInizio: "13 Aprile 2026", dataFine: "16 Giugno 2026", dataEsame: "17 Giugno 2026" },
      { dataInizio: "15 Settembre 2026", dataFine: "20 Novembre 2026", dataEsame: "23 Novembre 2026" },
      { dataInizio: "12 Gennaio 2027", dataFine: "18 Marzo 2027", dataEsame: "22 Marzo 2027" },
    ],
    durata: "120 ore",
    modalita: "Misto (presenza + videoconferenza)",
    sede: "Via Marco e Marcelliano, 45 – Roma",
    quota: "€ 430,00 (IVA esente)",
    formIscrizione: "https://forms.gle/iD6DixM8a2qcgDW96",
    immagine: "/local-assets/corsi/corso-agente-commercio.jpg",
    contatti: {
      tel: "340.8402544 – 06.68437462",
      email: "l.fedel@confcommercioroma.it",
    },
    finalita: `Il corso per Agente di Commercio è regolamentato dalla Regione Lazio e costituisce requisito obbligatorio per esercitare questa professione.

Al termine del corso è previsto un esame, superato il quale si rilascia l'abilitazione per esercitare la professione su tutto il territorio nazionale.

Gli sbocchi professionali prevedono di promuovere la vendita di prodotti, beni e servizi dell'azienda che si rappresenta, lavorando a stretto contatto con i clienti acquisiti e con i nuovi potenziali clienti.`,
    programma: [
      {
        titolo: "Tecniche di vendita",
        voci: [
          "Negoziazione e comunicazione efficace",
          "Tecniche di vendita e vendita comportamentale",
        ],
      },
      {
        titolo: "E-Commerce",
        voci: [
          "Marketing, Normativa sul commercio, E-Commerce",
          "Tecniche Web relative all'E-Commerce",
        ],
      },
      {
        titolo: "Disciplina legislativa, contrattuale e previdenziale",
        voci: [
          "Tutela previdenziale e assistenziale degli ARC",
          "Tutela socio-economica degli ARC",
          "Disciplina legislativo-contrattuale dell'attività",
        ],
      },
      {
        titolo: "Nozioni di diritto commerciale",
        voci: ["Diritto commerciale", "Nozioni di diritto penale"],
      },
      {
        titolo: "Normativa fiscale e organizzazione aziendale",
        voci: [
          "Legislazione tributaria e fiscale",
          "Amministrazione aziendale",
          "Elementi di contabilità e gestione amministrativa",
        ],
      },
    ],
    frequenzaNota: "Le lezioni si svolgeranno dal lunedì al giovedì con orario 14.00–18.00. Metà delle lezioni in videoconferenza su Zoom, metà in presenza presso la sede di Via Marco e Marcelliano 45 (zona Tor Marancia), fornita di parcheggio interno. La frequenza è obbligatoria con un massimo di 24 ore di assenza. L'esame finale si svolgerà in videoconferenza.",
    quotaNota: `Euro 430,00 IVA esente – include dispensa cartacea, materiale didattico digitale ed esercitazioni.

Pagamento in 2 rate:
• € 215,00 all'atto dell'iscrizione (comprensivi di marca da bollo € 2,00)
• € 215,00 entro il primo giorno di lezione dopo conferma del corso

Pagamento in unica soluzione: € 430,00 all'atto dell'iscrizione.

I pagamenti avvengono via bonifico alle coordinate presenti sul modulo di iscrizione.`,
    normativa: "https://www.regione.lazio.it/cittadini/formazione/repertorio-competenze/formazione-regolamentata",
    normativaCodice: "Cod. FA04",
  },
  {
    slug: "procedure-esecutive-immobiliari",
    codice: "ASTE",
    categoria: "Alta Formazione",
    categoriaColor: "#003B75",
    categoriaBg: "#EBF5FF",
    titolo: "Corso sulle Procedure Esecutive Immobiliari",
    sottotitolo: "Teoria e prassi di un mercato senza crisi",
    dataInizio: "14 Aprile 2026",
    dataFine: "5 Maggio 2026",
    sessioni: [
      { dataInizio: "14 Aprile 2026", dataFine: "5 Maggio 2026" },
      { dataInizio: "6 Ottobre 2026", dataFine: "27 Ottobre 2026" },
    ],
    durata: "16 ore",
    modalita: "Misto (presenza + videoconferenza Zoom)",
    sede: "Via Marco e Marcelliano, 45 – Roma",
    quota: "€ 155,00 + IVA (soci FIMAA Roma: € 115,00 + IVA)",
    formIscrizione: "https://docs.google.com/forms/d/e/1FAIpQLSciD5cPjt9v0_omOoHwkfwL_ABoQr4yp8rYhhyKN_I0I3pz7A/viewform",
    immagine: "/local-assets/corsi/procedure-esecutive-immobiliari.jpg",
    contatti: {
      tel: "06.68437462 – 340.8402544",
      email: "l.fedel@confcommercioroma.it",
    },
    finalita: `Nell'ambito del progetto "Aste Tour 2026", Promo.Ter, in collaborazione con Confcommercio Roma e Fimaa Roma, promuove il primo corso di formazione specifico sul mercato degli immobili in asta e pignorati.

Il percorso nasce per colmare un vuoto informativo in un settore in forte espansione, offrendo ai professionisti una visione chiara di un mercato complesso ma ricco di opportunità. Attraverso un approccio pratico, verranno analizzate le oltre 40.000 aggiudicazioni annue e l'impatto della Riforma Cartabia.`,
    programma: [
      {
        titolo: "Interventi Tecnico-Giuridici",
        voci: [
          "Nozioni, norme, procedure e tempi del funzionamento dei crediti immobiliari e delle aste giudiziarie",
          "Finanziabilità dei mutui in asta e per interruzione della procedura (saldo e stralcio)",
        ],
      },
      {
        titolo: "Interventi Commerciali e Pratici",
        voci: [
          "Organizzazione dell'agenzia, promozione dei servizi, gestione della notizia",
          "Modulistica, provvigioni e utilizzo dei portali immobiliari",
        ],
      },
    ],
    docente: "Dott. Fabio Spalvieri",
    materialeDidattico: ["Manuale del tutor", "Pillole web di approfondimento dei collaboratori", "Test di verifica finale"],
    obiettivi: [
      "Comprendere l'intero iter dell'esecuzione immobiliare",
      "Leggere e interpretare correttamente atti, perizie e ordinanze",
      "Finanziare un immobile in asta o pignorato",
      "Valutare rischi, opportunità e criticità di un immobile pignorato",
      "Operare professionalmente come consulenti specializzati o investitori",
    ],
    destinatari: [
      "Agenti immobiliari e Consulenti del credito",
      "Avvocati, Praticanti e Commercialisti",
      "Investitori immobiliari e Consulenti patrimoniali",
      "Amministratori condominiali",
    ],
    frequenzaNota: "4 moduli da 4 ore ciascuno — ogni martedì dal 14 Aprile al 5 Maggio 2026, orario 14.00–18.30 (pausa 30 min). In presenza: 1° e 3° modulo. In videoconferenza Zoom: 2° e 4° modulo.",
  },
  {
    slug: "agente-immobiliare",
    codice: "AIM",
    categoria: "Corso abilitante",
    categoriaColor: "#003B75",
    categoriaBg: "#EBF5FF",
    titolo: "Corso per Agente Immobiliare",
    dataInizio: "27 Aprile 2026",
    dataFine: "9 Luglio 2026",
    dataEsame: "14 Luglio 2026",
    sessioni: [
      { dataInizio: "27 Aprile 2026", dataFine: "9 Luglio 2026", dataEsame: "14 Luglio 2026" },
      { dataInizio: "5 Ottobre 2026", dataFine: "15 Dicembre 2026", dataEsame: "18 Dicembre 2026" },
    ],
    durata: "150 ore + 12 ore modulo pratico",
    modalita: "Misto (presenza + videoconferenza)",
    sede: "Via Marco e Marcelliano, 45 – Roma",
    quota: "€ 542,00 (IVA esente, comprensivi di marca da bollo € 2,00)",
    formIscrizione: "https://docs.google.com/forms/d/e/1FAIpQLSciD5cPjt9v0_omOoHwkfwL_ABoQr4yp8rYhhyKN_I0I3pz7A/viewform",
    immagine: "/local-assets/corsi/corso-agente-immobiliare.jpeg",
    contatti: {
      tel: "06.68437462 – 340.8402544",
      email: "promoter@confcommercioroma.it",
    },
    finalita: `Il corso per Agente Immobiliare è regolamentato dalla Regione Lazio e costituisce requisito obbligatorio per iscriversi all'esame camerale che abilita alla professione.

Al termine è prevista una prova finale interna, superata la quale si rilascia l'abilitazione per sostenere l'esame presso la Camera di Commercio.

Gli sbocchi professionali prevedono sia l'apertura di un'attività di intermediazione immobiliare in proprio, sia la possibilità di fornire consulenza e abilitazione a società o reti/franchising immobiliari già costituite.`,
    programma: [
      {
        titolo: "Materie istituzionali (Regione Lazio)",
        voci: [
          "Diritto civile e mediazione",
          "Estimo e stima immobiliare",
          "Diritto finanziario e commerciale",
          "Diritto tributario e contabilità",
        ],
      },
      {
        titolo: "Aspetti pratici della professione (modulo FIMAA Roma)",
        voci: [
          "Legge 39/89 e modifiche – Requisiti per iscrizione REA",
          "Acquisizione e gestione del cliente; metodi di stima immobiliare",
          "L'incarico di mediazione: modulistica FIMAA, clausole, mandato",
          "Diritti, doveri e responsabilità del mediatore immobiliare",
          "La proposta di acquisto: aspetti fiscali, caparra, registrazione",
          "Il preliminare di compravendita: aspetti giuridici e fiscali",
          "Marketing e comunicazione: digital marketing, social media, real estate",
        ],
      },
    ],
    frequenzaNota: "Lezioni lunedì–giovedì ore 09.00–13.00. Lunedì e martedì in presenza, mercoledì e giovedì in videoconferenza Zoom. Sono previste 12 ore aggiuntive su \"Aspetti pratici\" il giovedì in aula. Frequenza obbligatoria con massimo 30 ore di assenza su 150.",
    quotaNota: `€ 542,00 IVA esente – include libro di testo ("L'Agente Immobiliare" di Pizzullo, Cataldo, De Filippo), materiale didattico digitale ed esercitazioni.

Pagamento in 2 rate:
• € 272,00 all'atto dell'iscrizione (comprensivi di marca da bollo € 2,00)
• € 272,00 entro il primo giorno di lezione dopo conferma del corso

Pagamento in unica soluzione: € 542,00 all'atto dell'iscrizione.`,
    normativa: "https://www.regione.lazio.it/cittadini/formazione/repertorio-competenze/formazione-regolamentata",
    normativaCodice: "Cod. FA03",
  },
  {
    slug: "futuro-sicuro-2026",
    codice: "FS",
    categoria: "Alta Formazione",
    categoriaColor: "#003B75",
    categoriaBg: "#EBF5FF",
    titolo: 'Corso di Alta Formazione "FUTURO SICURO" 2026',
    dataInizio: "20 Maggio 2026",
    sessioni: [
      { dataInizio: "20 Maggio 2026" },
      { dataInizio: "14 Ottobre 2026" },
    ],
    durata: "18 ore",
    modalita: "FAD – Formazione a Distanza",
    quota: "€ 200,00 (gratuito per aziende iscritte a EBIT Lazio)",
    formIscrizione: null,
    immagine: "/local-assets/corsi/futuro-sicuro-card.jpg",
    contatti: {
      tel: "06.68.437.610",
      email: "g.tomassoni@confcommercioroma.it",
    },
    accreditamenti: [
      "Ordine degli Avvocati – 16 crediti formativi",
      "Ordine degli Assistenti Sociali – 18 crediti formativi",
    ],
    finalita: `Il corso "Futuro Sicuro" intende fornire strumenti concreti per riconoscere, prevenire e contrastare le diverse forme di violenza di genere, con un approccio multidisciplinare che integra aspetti giuridici, psicologici, sociali ed economici.

Il percorso formativo mira a far conoscere gli strumenti normativi e sociali di riferimento e ad acquisire competenze relazionali utili per gestire correttamente, all'interno del proprio contesto lavorativo, gli effetti di situazioni conflittuali e di violenza di genere.`,
    destinatari: [
      "Imprese di qualsiasi dimensione, istituzioni e associazioni che intendono adottare politiche di prevenzione in coerenza con i principi ESG, l'Agenda 2030 e le disposizioni sulla certificazione di genere",
      "Operatori del settore (avvocati, magistrati, assistenti sociali, educatori, insegnanti, medici, volontari) che necessitano di strumenti per distinguere la violenza dal conflitto",
    ],
    programma: [
      {
        titolo: "Temi del corso",
        voci: [
          "Violenza in rete: rischi, cyberstalking, revenge porn e tutela dei dati personali",
          "Tutela processuale penale: novità del Codice Rosso, indagini difensive, denuncia e querela",
          "Violenza economica: riconoscimento, prevenzione, educazione finanziaria e percorsi di supporto",
          "Aspetti legali civili: separazioni, divorzi, affidamento dei figli, ordini di protezione",
          "Aspetti psicologici: violenza psicologica, fisica e abusi nelle relazioni affettive e lavorative",
        ],
      },
    ],
    notaEBIT: "Le aziende iscritte a EBIT Lazio possono attivare il corso gratuitamente.",
  },
];
